export const INTRINSICALLY_SCALED_OVERLAY_MODES: ReadonlySet<string> = new Set([
  "dithered",
  "blue-noise",
  "blue_noise",
  "subpixel",
  "subpixel-size",
]);
